import { render, staticRenderFns } from "./Webservices.vue?vue&type=template&id=8f6ba848&"
import script from "./Webservices.vue?vue&type=script&lang=js&"
export * from "./Webservices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports